var React = require('react');

function Toothbrush (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M320 232a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v184h32zm64 0a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v184h32zm64 0a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v184h32zm-192 0a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v184h32zm368 216H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h608a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM64 232a8 8 0 0 0-8-8H40a8 8 0 0 0-8 8v184h32zm128 0a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v184h32zm-64 0a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v184h32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 128a64 64 0 0 1 64-64h261.49c33.4 0 50.13-40.38 26.51-64a128 128 0 0 1 128 128 64 64 0 0 1-64 64H64a64 64 0 0 1-64-64z","className":"fa-primary","key":2})]);
}

Toothbrush.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Toothbrush;

Toothbrush.default = Toothbrush;
